import { render, staticRenderFns } from "./Masthead.vue?vue&type=template&id=1f70722e&scoped=true&"
import script from "./Masthead.vue?vue&type=script&lang=ts&"
export * from "./Masthead.vue?vue&type=script&lang=ts&"
import style0 from "./Masthead.vue?vue&type=style&index=0&id=1f70722e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f70722e",
  null
  
)

export default component.exports